// ServicesSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const ServicesSection = ({
  clinicServices,
  form,
  handleServiceChange,
  errors,
  setForm,
}) => {
  const { t, i18n } = useTranslation();
  // Responsive grid columns based on screen size
  const getGridColumns = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width <= 768) return "repeat(2, 1fr)"; // Mobile: 2 columns
      if (width <= 1024) return "repeat(3, 1fr)"; // Tablet: 3 columns
      return "repeat(4, 1fr)"; // Desktop: 4 columns
    }
    return "repeat(4, 1fr)";
  };

  const [gridColumns, setGridColumns] = React.useState(getGridColumns());

  React.useEffect(() => {
    const handleResize = () => {
      setGridColumns(getGridColumns());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        padding: "0",
        width: "100%",
        maxWidth: "960px",
        margin: "0 auto",
      }}
      dir={i18n.dir()}
      lang={i18n.language}
    >
      {/* Modern Header */}
      <div style={{ marginBottom: "32px" }}>
        <h2 style={{ 
          fontSize: "24px", 
          fontWeight: "600", 
          color: "#1f2937",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          gap: "4px"
        }}>
          {t("clinicSetup.services.title")}
          <span style={{ color: "#ef4444", fontSize: "20px" }}>*</span>
        </h2>
        <p style={{ 
          fontSize: "14px", 
          color: "#6b7280",
          margin: 0
        }}>
          {t("clinicSetup.services.subtitle")}
        </p>
      </div>

      {/* Services Grid Card */}
      <div style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        padding: "24px"
      }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: gridColumns,
          gap: "16px"
        }}>
        {clinicServices.map((service) => {
          const selected = form.servicesOffered.includes(service.id);
          const serviceName =
            i18n.language === "ar" && service.name_ar
              ? service.name_ar
              : service.name_en;
          return (
            <div
              key={service.id}
              onClick={() =>
                handleServiceChange(service.id)({
                  target: { checked: !selected },
                })
              }
              style={{
                cursor: "pointer",
                background: selected ? "#eff6ff" : "#fff",
                border: selected ? "2px solid #3b82f6" : "2px solid #e5e7eb",
                borderRadius: "12px",
                padding: "20px",
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
                minHeight: "80px",
                position: "relative"
              }}
              onMouseEnter={(e) => {
                if (!selected) {
                  e.currentTarget.style.borderColor = "#d1d5db";
                  e.currentTarget.style.background = "#f9fafb";
                }
              }}
              onMouseLeave={(e) => {
                if (!selected) {
                  e.currentTarget.style.borderColor = "#e5e7eb";
                  e.currentTarget.style.background = "#fff";
                }
              }}
            >
              {selected && (
                <div style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  background: "#3b82f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "600"
                }}>
                  ✓
                </div>
              )}
              <span
                style={{
                  userSelect: "none",
                  pointerEvents: "none",
                  fontWeight: selected ? "600" : "500",
                  fontSize: "15px",
                  color: selected ? "#1e40af" : "#374151",
                  textAlign: "center",
                  lineHeight: "1.4"
                }}
              >
                {serviceName}
              </span>
            </div>
          );
        })}
        </div>
      </div>
      {errors.servicesOffered && (
        <div style={{ 
          color: "#ef4444", 
          fontSize: "14px", 
          marginTop: "20px",
          textAlign: "center",
          fontWeight: "500"
        }}>
          {errors.servicesOffered}
        </div>
      )}
    </div>
  );
};

export default ServicesSection;
